import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import unnamedLightLogo from '../../../assets/images/unnamed-light-logo.png';
import heroBg from '../../../assets/images/hero-bg.jpg';
import './HomeHeroSection.scss';

const NAV_LINKS = [
  { key: 'home.nav.philosophy', href: '#philosophy' },
  { key: 'home.nav.lume', href: '/lume' },
  { key: 'home.nav.puppy', href: '#puppy' },
  { key: 'home.nav.contact', href: '#contact' },
];

function HomeHeroSection() {
  const { t, i18n } = useTranslation();
  const isEn = !i18n.language?.startsWith('zh');

  const toggleLanguage = useCallback(() => {
    const next = i18n.language === 'zh' ? 'en' : 'zh';
    i18n.changeLanguage(next);
  }, [i18n]);

  const currentLang = i18n.language?.startsWith('zh') ? 'zh' : 'en';

  return (
    <section className={`home-hero ${isEn ? 'home-hero--en' : ''}`}>
      <div className="home-hero__bg">
        <img src={heroBg} alt="" className="home-hero__bg-img" />
      </div>
      <div className="home-hero__overlay" />

      <nav className="home-hero__nav">
        <a href="/" className="home-hero__brand">
          <img src={unnamedLightLogo} alt="Unnamed Light" className="home-hero__logo" />
          <span className="home-hero__brand-name">{t('home.hero.brand')}</span>
        </a>
        <div className="home-hero__nav-links">
          {NAV_LINKS.map((link) => (
            <a key={link.key} href={link.href} className="home-hero__nav-link">
              {t(link.key)}
            </a>
          ))}
          <button
            className="home-hero__lang-toggle"
            onClick={toggleLanguage}
            aria-label="Switch language"
          >
            {currentLang === 'zh' ? 'EN' : '中'}
          </button>
        </div>
      </nav>

      <div className="home-hero__content">
        <div className="home-hero__text-block">
          <h1 className="home-hero__title">{t('home.hero.title')}</h1>
          <p className="home-hero__subtitle">{t('home.hero.subtitle')}</p>
          <p className="home-hero__motto">{t('home.hero.motto')}</p>
        </div>
        <div className="home-hero__desc">
          <p>{t('home.hero.descLine1')}</p>
          <p>{t('home.hero.descLine2')}</p>
        </div>
      </div>
    </section>
  );
}

export default HomeHeroSection;
